module.exports = __webpack_public_path__ + "static/media/Hbook3.71949fc1.jpg";